import { grey } from "@mui/material/colors";

const styles = {
  poweredByLogo: {
    my: { xs: 1, md: 3 },
    width: { xs: 50, md: 70 },
  },
  root: {
    position: { xs: "relative", md: "absolute" },
    overflow: "hidden",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },

  sidebar: {
    p: { xs: 2, md: 4 },
    backgroundColor: "secondary.light",
    position: { xs: "relative", md: "absolute" },
    top: 0,
    bottom: 0,
    width: { xs: "100%", md: "45%" },
    overflowY: "auto",
  },
  main: {
    position: { xs: "relative", md: "absolute" },
    top: 0,
    bottom: 0,
    left: { xs: 0, md: "45%" },
    right: 0,
    p: { xs: 2, md: 4, lg: 6 },
    overflowY: "auto",
  },
  tabs: {
    borderBottom: `1px solid ${grey[300]}`,
  },
  tab: {
    textTransform: "none",
    fontSize: 11,
  },
  active: {
    borderRadius: 0,
    borderBottom: "2px solid",
  },
  annotation: {
    position: "relative",
    verticalAlign: "middle",
    fontSize: 8,
    ml: 0.5,
    color: "secondary.main",
  },
};

export default styles;
